import { InjectionToken } from '@angular/core';

import { AntragUiData } from './antrag-ui-data.interface';

export const ANTRAGS_OVERVIEW_UI_MAP = new InjectionToken<Map<number, AntragUiData>>('ANTRAGS_OVERVIEW_UI_DATA_MAP');
